<template>
    <div class="choose-template">
        <while-loading v-if="!loaded" />
        <div v-else>
            <table class="field-table" border v-if="JSON.stringify(tableData) !== '{}'">
                <tr v-for="item, k, index in tableData" :key="k">
                    <td> {{ item }} </td>
                    <td>
                        <el-checkbox v-model="checkList[k]" @change="handleChooesd($event, k)"></el-checkbox>
                    </td>
                </tr>
            </table>
            <div style="text-align: center;" v-else>
                没有数据~
            </div>
        </div>
    </div>
</template>

<script>
// src/commonReform/WhileLoading.vue
// src/pages/cloudClue/Components/SendSMS.vue
import WhileLoading from '../../../commonReform/WhileLoading'
export default {
    name: 'ChooseTemplate',
    components: { WhileLoading },
    props: {
        task_id: {
            type: Number
        }
    },
    data() {
        return {
            tableData: {},
            loaded: false,
            checkList: {},
        }
    },
    methods: {
        loadTable() {
            this.$axios.get('/api/api3_call_task/load_template', {
                loadingClose: true,
                params: {
                    task_id: this.task_id
                }
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.loaded = true
                    this.tableData = data.data
                }
            }).catch()
        },
        handleChooesd(e, val) {
            for (let key in this.checkList) {
                if (key === val) {
                    this.checkList[key] = true
                } else {
                    this.checkList[key] = false
                }
            }
            this.$emit('handleChooesd', val)
        },
    },
    mounted() {
        this.loadTable()
    }
}
</script>

<style scoped>
/* 表格 */
.choose-template .centered {
    /* 水平居中 */
    text-align: center;
    /* 垂直居中 */
    vertical-align: middle;
}

.choose-template .field-table td {
    padding: 0.2rem 0.3rem;
}

.choose-template .centered-count {
    text-align: right;
}

/* 表格end */
</style>


// WEBPACK FOOTER //
// src/pages/cloudClue/Components/ChooseTemplate.vue